const PREFIX = 'LOCAL_STORAGE_WITH_TTL_'
const TYPED_KEY = /^PatientHistoryForm-(.+)-([A-Z0-9_]+)$/

export type BrowserNoteDraft = {
  uid: string
  type: string
  value: Record<string, unknown>
  storageKey: string
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value)

export const listUnexpiredBrowserNoteDrafts = (now = Date.now()): BrowserNoteDraft[] => {
  const drafts: BrowserNoteDraft[] = []

  Object.keys(window.localStorage).forEach((storageKey) => {
    if (!storageKey.startsWith(PREFIX)) {
      return
    }
    const logical = storageKey.slice(PREFIX.length)
    const raw = window.localStorage.getItem(storageKey)
    if (!raw) {
      return
    }
    let parsed: { expiresAt?: number; value?: unknown }
    try {
      parsed = JSON.parse(raw)
    } catch {
      return
    }
    if (typeof parsed.expiresAt === 'number' && parsed.expiresAt < now) {
      return
    }
    if (!isRecord(parsed.value)) {
      return
    }

    const typedMatch = logical.match(TYPED_KEY)
    if (typedMatch) {
      drafts.push({ uid: typedMatch[1], type: typedMatch[2], value: parsed.value, storageKey: logical })
    }
  })

  return drafts
}

export const clearBrowserNoteDraft = (storageKey: string) => {
  window.localStorage.removeItem(`${PREFIX}${storageKey}`)
}

export const readBrowserNoteDraft = ({ uid, type }: { uid: string; type: string }): Record<string, unknown> | null => {
  const match = listUnexpiredBrowserNoteDrafts().find((draft) => draft.uid === uid && draft.type === type)
  return match?.value ?? null
}
